import { Role } from '@caresend/types';
import { isNullish } from '@caresend/utils';
import { usePortalStore } from '../portal/store/portal/index.js';
import { getNurseItineraryStatusDisplay, getDefaultItineraryStatusDisplay } from './helpers.js';
import '@sentry/vue';
import { toastError } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import 'immutability-helper';
import { getRouter } from '../../../router/helpers/initRouter.js';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import { portalItineraryRoute } from '../../../router/routes/portal/locations.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../portal/store/portal/sessionStore.js';
import 'vue';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import { getUserRole } from '../../../store/helpers.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/app/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/pinia/draftWaypoints/index.js';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

const getItineraryEndTime = (itinerary) => {
    var _a;
    if (!itinerary.startTime
        || isNullish((_a = itinerary.startTime) === null || _a === void 0 ? void 0 : _a.timestamp)
        || isNullish(itinerary.duration))
        return;
    const durationSec = itinerary.duration * 60 * 1000;
    return {
        ...itinerary.startTime,
        timestamp: itinerary.startTime.timestamp + durationSec,
    };
};
const getItineraryStatusDisplay = (itineraryStatus, 
/** If not undefined, we have a nurse user and use this to determine the display */
nurseViewItineraryStatus) => nurseViewItineraryStatus
    ? getNurseItineraryStatusDisplay(nurseViewItineraryStatus)
    : getDefaultItineraryStatusDisplay(itineraryStatus);
const getAuthedNurseIsAssignedToItinerary = (itineraryID) => {
    var _a, _b;
    if (getUserRole() !== Role.NURSE)
        return false;
    const nurseIdOnItinerary = (_a = usePortalStore().itineraries.getters
        .assignedNurse(itineraryID)) === null || _a === void 0 ? void 0 : _a.id;
    return nurseIdOnItinerary === ((_b = getStore().state.auth.user) === null || _b === void 0 ? void 0 : _b.id);
};
const getAuthedNurseIsAssignedToShift = (itineraryID) => {
    var _a;
    if (getUserRole() !== Role.NURSE)
        return false;
    const shift = usePortalStore().itineraries.getters.shift(itineraryID);
    const nurseIdOnShift = shift === null || shift === void 0 ? void 0 : shift.userID;
    return nurseIdOnShift === ((_a = getStore().state.auth.user) === null || _a === void 0 ? void 0 : _a.id);
};
const handleItineraryClick = (itineraryID) => {
    /** If the accessing user is not a nurse, they can view the itinerary */
    if (getUserRole() !== Role.NURSE) {
        return getRouter().push(portalItineraryRoute(itineraryID));
    }
    const authedNurseIsAssignedToItinerary = getAuthedNurseIsAssignedToItinerary(itineraryID);
    const authedNurseIsAssignedToShift = getAuthedNurseIsAssignedToShift(itineraryID);
    const authedNurseNotAssigned = !authedNurseIsAssignedToItinerary
        || !authedNurseIsAssignedToShift;
    if (authedNurseNotAssigned) {
        toastError('You must accept the shift to view this itinerary');
    }
    else {
        getRouter().push(portalItineraryRoute(itineraryID));
    }
};

export { getItineraryEndTime, getItineraryStatusDisplay, handleItineraryClick };
